import { createSelector } from 'reselect';

export const getUser = createSelector(
	(state, props) => {
		return _getUser(state.service);
	},
	state => state
);

export const _getUser = service => {
	if (service.user && service.user.connectedAs) {
		return service.user.connectedAs;
	} else {
		return service.user;
	}
};

export const connectedAsMaster = createSelector(
	(state, props) => {
		return _connectedAsMaster(state.service);
	},
	state => state
);

const _connectedAsMaster = service => {
	return service.user.children.length && !service.user.connectedAs;
};
